import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AcuerdoAmbitoGeograficoControllerService } from './api/acuerdoAmbitoGeograficoController.service';
import { AcuerdoIndirectoControllerService } from './api/acuerdoIndirectoController.service';
import { AcuerdoIndirectoEstadosControllerService } from './api/acuerdoIndirectoEstadosController.service';
import { AportacionDiAcuerdosGestoresControllerService } from './api/aportacionDiAcuerdosGestoresController.service';
import { ConsentimientoControllerService } from './api/consentimientoController.service';
import { ConsentimientoEstadosControllerService } from './api/consentimientoEstadosController.service';
import { ConsentimientoPoseedorControllerService } from './api/consentimientoPoseedorController.service';
import { FacturaGestorAcuerdoControllerService } from './api/facturaGestorAcuerdoController.service';
import { GestoresConAcuerdoControllerService } from './api/gestoresConAcuerdoController.service';
import { GestoresResiduosEstadosControllerService } from './api/gestoresResiduosEstadosController.service';
import { HelloWorldControllerService } from './api/helloWorldController.service';
import { PlataformaOrigenControllerService } from './api/plataformaOrigenController.service';
import { PoseedorControllerService } from './api/poseedorController.service';
import { TarifaGestoresControllerService } from './api/tarifaGestoresController.service';
import { DiccionarioControllerService } from './api/diccionarioController.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AcuerdoAmbitoGeograficoControllerService,
    AcuerdoIndirectoControllerService,
    AcuerdoIndirectoEstadosControllerService,
    AportacionDiAcuerdosGestoresControllerService,
    ConsentimientoControllerService,
    ConsentimientoEstadosControllerService,
    ConsentimientoPoseedorControllerService,
    FacturaGestorAcuerdoControllerService,
    GestoresConAcuerdoControllerService,
    GestoresResiduosEstadosControllerService,
    HelloWorldControllerService,
    PlataformaOrigenControllerService,
    PoseedorControllerService,
    TarifaGestoresControllerService,
    PoseedorControllerService,
    DiccionarioControllerService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
